import React, { FunctionComponent, useState, useEffect } from 'react';
import ICategory from '../../../../../model/ICategory';
import FeatureCategory from '../featureCategory/FeatureCategory';
import IFeature from '../../../../../model/IFeature';
import useSalesEnablementContext from '../../../../../../gqlCommon/hooks/useSalesEnablementContext';

export interface IFeatureCategoryListProps {
  categories: ICategory[];
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const FeatureCategoryList: FunctionComponent<IFeatureCategoryListProps> = ({
  categories,
  openAccessoryDetailsModal,
}) => {
  const [expandedPanelId, setExpanded] = useState('panel_0');
  const { setFirstDealerOptionIndex } = useSalesEnablementContext();

  useEffect(() => {
    const index = categories.findIndex(item =>
      item.featuresList.features.some(feature => !!feature && feature.attributes.salespersonViewOnly === true),
    );

    if (index !== -1) {
      setFirstDealerOptionIndex(index);
    }
  }, [categories]);

  return (
    <>
      {categories?.map((category, value) => (
        <FeatureCategory
          key={value}
          category={category}
          id={value}
          expandedPanelId={expandedPanelId}
          setExpanded={setExpanded}
          openAccessoryDetailsModal={openAccessoryDetailsModal}
        />
      ))}
    </>
  );
};

export default FeatureCategoryList;
